module.exports = __webpack_public_path__ + "img/true.38132958.png";